import React from 'react';
import { Button } from 'reactstrap';
import filterIcon from '../../Res/Icon/filter.png';
import './index.css'; 

const FILTER_OPTIONS = ['Serial Number', 'Device Name', 'BTN'];

export default function OobmFilterBar({
  field,
  value,
  onChangeField,
  onChangeValue,
  onSearch,
  onKeyDown,
}) {
  return (
    <div className="oobm-filter oobm-filter-strip">
      <div className="oobm-toolbar">
        <div className="oobm-filter-wrap">
          <div className="oobm-chip" aria-hidden="true">
            <img src={filterIcon} alt="" className="oobm-chip__img" draggable="false" />
          </div>

          <select
            className="oobm-select form-control"
            value={field}
            onChange={(e) => onChangeField(e.target.value)}
            aria-label="Filter field"
          >
            {FILTER_OPTIONS.map((o) => (
              <option key={o} value={o}>{o}</option>
            ))}
          </select>
        </div>

        <input
          className="oobm-input is-elevated"
          placeholder="Filter"
          value={value}
          onChange={(e) => onChangeValue(e.target.value)}
          onKeyDown={onKeyDown}
          aria-label="Filter text"
        />
        <Button className="oobm-search-btn is-pill" color="primary" onClick={onSearch}>
          Search
        </Button>
      </div>
    </div>
  );
}
